import { useRouteError } from "react-router-dom";
import "./ErrorPage.scss";

export default function ErrorPage() {
  const error = useRouteError();

  return (
    <section className="error-page">
      <h1>Error</h1>
      <h2>
        {error.status} {error.statusText}
      </h2>
    </section>
  );
}
